import React, { useState } from "react";
import hide from "../../images/hide.png";
import { Link, Redirect, useHistory, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useMutation } from "@apollo/react-hooks";
import { SIGN_UP } from "../../mutation/signup";
import * as Yup from "yup";
import SignupLayout from "./SignupLayout";

const SignupAccount = () => {
  const [SignUp] = useMutation(SIGN_UP);
  const [visiblePassword, setVisiblePassword] = React.useState(false);
  const [visiblePassword2, setVisiblePassword2] = useState(false);

  const history = useHistory();

  const params = useParams();

  const SignupAccountMain = (
    <SignupLayout>
      <div className="login-cover signup-account">
        <div className="login-box">
          <h1>Create an account</h1>

          <Formik
            initialValues={{
              fullname: "",
              email: "",
              password: "",
              confirmpassword: "",
              acceptTerms: false,
            }}
            validationSchema={Yup.object({
              fullname: Yup.string().required("Please enter your fullname"),
              email: Yup.string()
                .email("Invalid Email Address")
                .required("Please enter your email"),
              password: Yup.string()
                .required("Please enter your password")
                .min(
                  8,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[a-z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[A-Z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /.*[0-9].*/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /(?=.*[!@#$%^&*])/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                ),
              confirmpassword: Yup.string()
                .required("Please enter your confirm password")
                .min(
                  8,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[a-z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /[A-Z]/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /.*[0-9].*/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                )
                .matches(
                  /(?=.*[!@#$%^&*])/,
                  "Minimum 8 characters long with at least one uppercase letter, one lowercase letter, one number, and one special character"
                ),
              acceptTerms: Yup.bool()
                .oneOf([true], "You must accept terms and conditions")
                .required(),
            })}
            onSubmit={(values, { setFieldError, setSubmitting }) => {
              if (values.password === values.confirmpassword) {
                SignUp({
                  variables: {
                    full_name: values.fullname,
                    email: values.email,
                    password: values.password,
                    role: "BUSINESS",
                    referral_id: params.id,
                  },
                })
                  .then((response) => {
                    localStorage.setItem("resend_signup_email", values.email);
                    const { accessToken, refreshToken } = response.data.signUp;
                    localStorage.setItem("jwt_token", accessToken);
                    localStorage.setItem("refresh_token", refreshToken);

                    localStorage.setItem(
                      "user_id",
                      response.data.signUp.data.userId
                    );

                    setSubmitting(false);
                    history.push("/signup/1");
                  })
                  .catch((e) => {
                    const errors = e.graphQLErrors;
                    if (errors[0] && errors[0].message) {
                      setFieldError("acceptTerms", errors[0].message);
                    }
                    setSubmitting(false);
                  });
              } else {
                setFieldError("confirmpassword", "Password does not match");
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form className="login-form">
                <div className="form-group">
                  <label>Full Name</label>
                  <Field
                    type="fullname"
                    name="fullname"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="fullname"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <Field type="email" name="email" className="form-control" />
                  <ErrorMessage
                    component="div"
                    name="email"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label>Password</label>
                  <div className="hide-icon">
                    <Field
                      name="password"
                      type={visiblePassword ? "text" : "password"}
                      className="form-control"
                    />
                    <img
                      src={hide}
                      onClick={() => setVisiblePassword(!visiblePassword)}
                      alt="password hide"
                    />
                  </div>
                  <ErrorMessage
                    component="div"
                    name="password"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label>Confirm Password</label>
                  <div className="hide-icon">
                    <Field
                      name="confirmpassword"
                      type={visiblePassword2 ? "text" : "password"}
                      className="form-control"
                    />
                    <img
                      src={hide}
                      onClick={() => setVisiblePassword2(!visiblePassword2)}
                      alt="password hide"
                    />
                  </div>
                  <ErrorMessage
                    name="confirmpassword"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="signup-terms">
                  <label style={{ marginBottom: "0px" }} class="checkbox">
                    {" "}
                    I accept <a href={`${process.env.REACT_APP_TERMS_URL}/terms?term=true`} target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                    
                    <Field
                      type="checkbox"
                      name="acceptTerms"
                      id="acceptTerms"
                      className=""
                    />
                    <span class="checkmark"></span>
                  </label>
                  <ErrorMessage
                    name="acceptTerms"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-submit">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="submit-btn"
                  >
                    Submit
                  </button>
                </div>

                <p className="account-already-row">
                  Already have an account? <Link to="/login"> Login </Link>
                </p>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </SignupLayout>
  );

  const token = localStorage.getItem("jwt_token");
  if (!token) {
    return SignupAccountMain;
  } else if (
    localStorage.getItem("profile_id") &&
    localStorage.getItem("is_profile_setup")
  ) {
    return <Redirect to="/dashboard" />;
  } else {
    return SignupAccountMain;
  }
};

export default SignupAccount;
